import React from 'react';
import { useTranslation } from 'react-i18next';

import type { SuggestionNav } from '../../lib/useSuggestionPager';
import { ChevronLeftIcon, ChevronRightIcon } from '../icons';
import { Bar, NavBtn } from './SuggestionPager.styles';

export interface SuggestionPagerProps {
  /** Navigation state from `useSuggestionPager` (index/count + back/forward). */
  nav: SuggestionNav;
}

/**
 * Back / forward arrows beneath a suggestions list. Appears only once the user
 * has refreshed at least once (more than one page revealed); each arrow moves
 * only within the pages already seen, disabling at the ends of that history.
 */
export const SuggestionPager = ({ nav }: SuggestionPagerProps): React.ReactElement | null => {
  const { t } = useTranslation();
  if (nav.count <= 1) return null;
  return (
    <Bar>
      <NavBtn type="button" onClick={nav.back} disabled={!nav.canBack} aria-label={t('Previous suggestions')}>
        <ChevronLeftIcon size={18} />
      </NavBtn>
      <NavBtn type="button" onClick={nav.forward} disabled={!nav.canForward} aria-label={t('Next suggestions')}>
        <ChevronRightIcon size={18} />
      </NavBtn>
    </Bar>
  );
};

export default SuggestionPager;
